<script setup>
defineOptions({ name: "SupportChamadoSection" });

defineProps({
  portalUrl: { type: String, default: "" },
});

const ticketSteps = [
  "Informe o módulo ou funcionalidade com problema",
  "Descreva o que estava fazendo quando o erro ocorreu",
  "Anexe prints ou mensagens de erro, se houver",
  "Indique a urgência: baixa, média ou alta",
];

// Revela o elemento com fade+slide assim que ele entra na viewport ao rolar a página.
const vReveal = {
  mounted(el) {
    el.classList.add("reveal-init");
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("reveal-visible");
          io.disconnect();
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" },
    );
    io.observe(el);
  },
};
</script>

<template>
  <section id="chamado" class="py-16 bg-white scroll-mt-24">
    <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div v-reveal class="max-w-2xl">
        <h2
          class="text-4xl sm:text-5xl font-black tracking-tight !leading-[1.25] pb-2 text-transparent bg-clip-text bg-gradient-to-r from-gray-900 via-[#006086] to-[#004d6b]"
        >
          Abra um chamado
        </h2>
      </div>

      <div class="grid gap-10 mt-6 lg:grid-cols-2 lg:items-start">
        <div v-reveal>
          <p class="text-lg text-gray-600">
            Para um atendimento mais ágil, tenha em mãos as seguintes
            informações antes de abrir seu chamado:
          </p>
          <ul class="mt-6 space-y-3">
            <li
              v-for="(step, i) in ticketSteps"
              :key="step"
              class="flex gap-3 items-start text-sm text-gray-700"
            >
              <span
                class="w-6 h-6 rounded-full bg-[#006086] text-white text-xs flex items-center justify-center flex-shrink-0 mt-0.5 font-bold"
              >
                {{ i + 1 }}
              </span>
              {{ step }}
            </li>
          </ul>
        </div>

        <div
          v-reveal
          class="flex flex-col gap-4 p-8 bg-[#e6f0f4] rounded-2xl"
        >
          <h3 class="text-xl font-bold text-gray-900">Portal de chamados</h3>
          <p class="text-sm text-gray-600">
            Acesse o portal para abrir, acompanhar e consultar o histórico dos
            seus atendimentos.
          </p>
          <a
            :href="portalUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex justify-center items-center px-6 py-3 rounded-xl text-base font-semibold bg-[#006086] text-white hover:bg-[#004d6b] transition-colors"
          >
            Acessar portal de chamados
          </a>
          <a
            href="/contato?type=suporte"
            class="inline-flex justify-center items-center px-6 py-3 rounded-xl text-base font-semibold bg-transparent text-[#006086] border border-[#006086] hover:bg-slate-50 transition-colors"
          >
            Falar pelo formulário de contato
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.reveal-init {
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.reveal-visible {
  opacity: 1;
  transform: translateY(0);
}

@media (prefers-reduced-motion: reduce) {
  .reveal-init {
    opacity: 1;
    transform: none;
    transition: none;
  }
}
</style>
